module.exports = __webpack_public_path__ + "static/media/WhiffRates.268f8ef5.pdf";